import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'conditionLineBottom'
})
export class ConditionLinePipe implements PipeTransform {

  transform( position: number, length: number) {
    
    if(length <5){
      return 'condition-line-bottom';
    } else if(length ===5 && (position+1) !== length) {
      return 'condition-line-bottom';
    }else{
      return '';
    }
  }

}
